var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLike(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 9.99979L6 10.0113V21.0114L2 20.9999L2 9.99979Z",
    fill: "#00AA4F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.15 4.51708C17.15 2.68566 14 2.68566 14 3.60137C14.2441 7.82274 12.1273 9.7614 10.5363 10.7053C10.2129 10.8972 10 11.2366 10 11.6126V19.4999C10 20.0522 10.4473 20.4999 10.9996 20.4999L16 20.4999C17 20.5 16.7 20.4999 18.5 20.4999C19.5 20.4999 20.6689 19.2574 21 17.9999C21.3312 16.7424 22 13.4156 22 12.4999C22 11.5842 21.9 10.0112 20.1 10.0112H18.1489C17.5966 10.0112 17.15 9.56355 17.15 9.01126V4.51708Z",
    fill: "#00AA4F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2 9.99979L6 10.0113V21.0114L2 20.9999L2 9.99979Z",
    stroke: "#00AA4F",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.15 4.51708C17.15 2.68566 14 2.68566 14 3.60137C14.2441 7.82274 12.1273 9.7614 10.5363 10.7053C10.2129 10.8972 10 11.2366 10 11.6126V19.4999C10 20.0522 10.4473 20.4999 10.9996 20.4999L16 20.4999C17 20.5 16.7 20.4999 18.5 20.4999C19.5 20.4999 20.6689 19.2574 21 17.9999C21.3312 16.7424 22 13.4156 22 12.4999C22 11.5842 21.9 10.0112 20.1 10.0112H18.1489C17.5966 10.0112 17.15 9.56355 17.15 9.01126V4.51708Z",
    stroke: "#00AA4F",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLike);
export default __webpack_public_path__ + "static/media/like.e06a53372e26627fb873785f9112d8ec.svg";
export { ForwardRef as ReactComponent };